/*
 * Copyright (c) 2025
 * Honeywell confidential. For internal use only.
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 * Use of source code must follow all Honeywell policies including the
 * HCE Source Code Access Policy [http://go.honeywell.com/hce-code-access-policy].
 * External use or distribution prohibited without written approval per Honeywell policies.
 */
import i18next from '../../i18next';

const NoSubscription = () => {
  return (
    <div className="flex items-center justify-center mt-8">
      {i18next.t('noSubscription')}
    </div>
  );
};

export default NoSubscription;
